const Tactic = require('../../entities/Tactic');
const { Age }  = require("../Constants");
const TacticNames = require("../Names/TacticNames");

class NapoleonicArmy extends Tactic {
    constructor() {
        super(
            Age.Age2,
            TacticNames.NapoleonicArmy,
            [1, 1, 1],
            "7(4)",
            {}
        )
    }
}

module.exports = NapoleonicArmy;